'use client';
import React, { useEffect, useState } from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import Media from '@pezeshk-book/ui-kit/media';
import Modal from '@pezeshk-book/ui-kit/modal';
import Text from '@pezeshk-book/ui-kit/text';
import Image from '@elements/image';
import { Chip } from '@pezeshk-book/ui-kit';
import convertDate from '@utils/time/convert-date';
import moment from 'moment';

const WorkHoursModal = () => {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const currentDate = convertDate(new Date(), 'YYYY-MM-DD', 'en');
    const token = sessionStorage.getItem('is_seen_work_hours_modal');
    const isActive = moment(currentDate).isBetween(process.env.WORK_HOURS_START_DATE, process.env.WORK_HOURS_END_DATE, null, '[]');
    if (isActive && !token) {
      sessionStorage.setItem('is_seen_work_hours_modal', 'seen');
      setOpenModal(true);
    }
  }, []);

  const onCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Modal open={openModal} onClose={onCloseModal}>
      <Div className={'flex-col w-11/12 sm:w-10/12 md:w-2/3 relative bg-white px-5 pb-5 rounded-xl items-center border-2 border-solid !border-[#037F6E] gap-4'}>
        <Div className={'absolute left-1 top-1 md:left-4 md:top-4'}>
          <Chip color={'danger'} onDelete={onCloseModal} onClick={onCloseModal} value={'بستن'} variant={'outlined'}/>
        </Div>
        <Div className={'relative h-40 w-56 md:h-64 md:w-96 object-contain -mt-20 md:-mt-32'}>
          <Image
            alt={'ساعات کاری'}
            src={'/images/home-screen/work-hours/bell.svg'}
            fill={true}
            className={'object-contain'}
          />
        </Div>
        <Div className={'flex-col w-full sm:w-4/5 md:w-3/5 gap-4'}>
          <Text type={'bold'} color={'grey.900'} typography={'lg'}>کاربر گرامی</Text>
          <Text color={'grey.900'} typography={'lg'}>{process.env.WORK_HOUR_EVENT_DESCRIPTION}</Text>
          <Text className={'mt-8'} type={'bold'} color={'grey.900'} typography={'lg'}>
            ساعات کاری {process.env.EVENT_NAME} <Text type={'bold'} color={'primary'} variant={'span'} typography={'lg'}>{process.env.BEGINNING_WORK_HOUR}</Text> الی <Text type={'bold'} color={'primary'} variant={'span'} typography={'lg'}>{process.env.ENDING_WORK_HOUR}</Text> می باشد.
          </Text>
        </Div>

        <Media greaterThan={'sm'}>
          <Div className={'absolute right-3 bottom-3'}>
            <Div className={'relative h-72 w-32 min-h-72 max-h-72 min-w-32'}>
              <Image
                alt={'ساعات کاری'}
                src={'/images/home-screen/work-hours/doctor.svg'}
                fill={true}
                className={'object-contain'}
              />
            </Div>
          </Div>
        </Media>
      </Div>
    </Modal>
  );
};

export default WorkHoursModal;
